import { createSlice } from '@reduxjs/toolkit';
import SmsOverageBillingService from '../../services/smsOverageBilling';

const initialState = {
  isLoading: false,
  isSaving: false,
  error: false,
  items: [],
  paging: { page: 1, pageSize: 20, total: 0 }
};

const slice = createSlice({
  name: 'smsOverageBilling',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = false;
    },
    startSaving(state) {
      state.isSaving = true;
      state.error = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.isSaving = false;
      state.error = action.payload;
    },
    getListSuccess(state, action) {
      state.isLoading = false;
      state.items = action.payload.items;
      state.paging = action.payload.paging;
    },
    updateItemSuccess(state, action) {
      state.isSaving = false;
      const updated = action.payload;
      state.items = state.items.map((item) =>
        item.id === updated.id ? { ...item, ...updated } : item
      );
    }
  }
});

export default slice.reducer;
const { startLoading, startSaving, hasError, getListSuccess, updateItemSuccess } = slice.actions;

export const fetchBillingList = (params) => async (dispatch) => {
  dispatch(startLoading());
  const result = await SmsOverageBillingService.getList(params);
  if (result.success) {
    dispatch(getListSuccess(result.data));
  } else {
    dispatch(hasError(result.errors?.[0]?.message || 'Failed to load billing records'));
  }
};

export const updateBillingRecord = (id, dto) => async (dispatch) => {
  dispatch(startSaving());
  const result = await SmsOverageBillingService.update(id, dto);
  if (result.success) {
    dispatch(updateItemSuccess(result.data));
    return { success: true };
  } else {
    dispatch(hasError(result.errors?.[0]?.message || 'Failed to update record'));
    return { success: false, error: result.errors?.[0]?.message };
  }
};
